import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Close } from "@material-ui/icons";

import { Store } from "../interface";
import { CLOSE_ALERT_SNACKBAR } from "../store/types";

const AlertSnackbar: React.FC = () => {
  const { color, open, text } = useSelector((state: Store) => state.temp.alertSnackbar);
  const dispatch = useDispatch();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      autoHideDuration={6000}
      onClose={() => dispatch({ type: CLOSE_ALERT_SNACKBAR })}
    >
      <Alert
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => dispatch({ type: CLOSE_ALERT_SNACKBAR })}
          >
            <Close fontSize="small" />
          </IconButton>
        }
        severity={color}
        color={color}
        variant="filled"
      >
        {text}
      </Alert>
    </Snackbar>
  );
};

export default AlertSnackbar;
